export default "__VITE_ASSET__BKAJ7tQA__"